import React, { useEffect, useState } from "react";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { toast } from "react-toastify";
import BackArrowIcon from "../../../components/Icons/BackArrowIcon";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { useLocation, useNavigate } from "react-router-dom";
import { useFieldArray, useForm, Controller } from "react-hook-form";
import { DatePicker } from "rsuite";
import { Spinner } from "reactstrap";
import ErrorMessage from "../../../components/comman/ErrorMessage";
import moment from "moment";
import { useSelector } from "react-redux";
import UploadPlusIcon from "../../../components/Icons/UploadPlusIcon";
import DeleteIcon from "../../../components/Icons/DeleteIcon";
import PlusIcon from "../../../components/Icons/PlusIcon";
import { UnitCollection } from "../../../utility/CommonFunctions";
import ViewDocumentModal from "../../Sites/ViewDocumentModal";
import MultipleGTC from "../../SupplyChain/Purchase/MultipleGTC";

export default function AddWorkOrder() {
  const navigate = useNavigate();
  const location = useLocation();
  // console.log("location===>", location?.state?.data);
  const userDetails = useSelector((state) => state.root.userDetails);
  const [existingDocuments, setExistingDocuments] = useState([]);
  const [files, setFiles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState();
  const [modal, setModal] = useState(false);
  const [state, setState] = useState({
    phone: [],
    email: [],
    workOrderDetails: null,
    startDate: "",
    endDate: "",
  });
  // console.log("startDate===>", state?.startDate, "endDate===>", state?.endDate);
  const toggleModal = () => {
    setModal(!modal);
  };
  const [siteList, setSiteList] = useState({
    OandMSites: [],
    projectSites: [],
    assignedSites: [],
  });
  const [totals, setTotals] = useState({
    taxableAmount: 0,
    totalGstAmount: 0,
    totalAmount: 0,
  });

  const {
    control,
    register,
    handleSubmit,
    reset,
    setValue,
    getValues,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      workOrderItem: [
        {
          itemId: "",
          originalQuantity: "",
          item: "",
          hsnCode: "",
          quantity: "",
          unit: "",
          gst: "",
          gstAmount: "",
          rate: "",
          totalAmount: "",
          taxableAmount: "",
        },
      ],
      taxableAmount: 0,
      totalAmount: 0,
    },
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "workOrderItem",
  });

  const watchFields = watch("workOrderItem");

  const handleQtyChange = (index) => {
    const { quantity, rate, gst } = getValues(`workOrderItem.${index}`);

    const qty = Number(quantity) || 0;
    const rateValue = Number(rate) || 0;
    const gstPercentage = Number(gst) || 0;

    const totalAmount = qty * rateValue;
    const gstAmount = (totalAmount * gstPercentage) / 100;
    const taxableAmount = totalAmount + gstAmount;

    setValue(`workOrderItem.${index}.totalAmount`, totalAmount.toFixed(2));
    setValue(`workOrderItem.${index}.gstAmount`, gstAmount.toFixed(2));
    setValue(`workOrderItem.${index}.taxableAmount`, taxableAmount.toFixed(2));

    updateTotals();
  };

  const updateTotals = () => {
    const items = getValues("workOrderItem") || [];

    let totalTaxable = 0;
    let totalGst = 0;
    let totalOverall = 0;

    items.forEach((item) => {
      totalTaxable += Number(item?.totalAmount) || 0;
      totalGst += Number(item?.gstAmount) || 0;
      totalOverall += Number(item?.taxableAmount) || 0;
    });

    setTotals({
      taxableAmount: totalTaxable.toFixed(2),
      totalGstAmount: totalGst.toFixed(2),
      totalAmount: totalOverall.toFixed(2),
    });

    setValue("taxableAmount", totalTaxable.toFixed(2));
    setValue("totalAmount", totalOverall.toFixed(2));
  };

  useEffect(() => {
    updateTotals();
  }, [watchFields]);

  useEffect(() => {
    if (userDetails?.type === 2) {
      GetAllSitesList();
    } else {
      getAssignedSites();
    }
    const GetWorkOrderDetail = () => {
      let options = {
        method: "GET",
      };
      let API =
        apiUrl?.get_work_order_detail +
        `?workorderId=${location?.state?.data?.id}`;
      setIsLoading(true);
      callApi(API, options).then((response) => {
        setIsLoading(false);
        if (response?.status === true) {
          setState((prev) => ({
            ...prev,
            workOrderDetails: response?.data,
          }));
        } else {
          toast.error(response?.message);
        }
      });
    };
    if (location?.state?.data) {
      GetWorkOrderDetail();
    }
  }, []);

  useEffect(() => {
    if (location?.state?.data && state.workOrderDetails) {
      const workOrderDetails = state.workOrderDetails;
      setState((prev) => ({
        ...prev,
        phone: workOrderDetails?.phone
          ? JSON.parse(workOrderDetails?.phone)
          : [],
        email: workOrderDetails?.email
          ? JSON.parse(workOrderDetails?.email)
          : [],
        startDate: workOrderDetails?.site?.startDate || "",
        endDate: workOrderDetails?.site?.endDate || "",
      }));
      const formattedItems = workOrderDetails?.workorderitems?.map((item) => ({
        itemId: item.id,
        item: item.item || "",
        hsnCode: item.hsnCode || "",
        quantity: item.quantity || "",
        originalQuantity: item.quantity || 0,
        unit: item.unit || "",
        gst: item.gst || 0,
        gstAmount: item.gstAmount || 0,
        rate: item.rate || "",
        totalAmount: item.totalAmount || "",
        taxableAmount: item.taxableAmount || "",
      }));
      reset({
        workOrderItem: formattedItems,
        workOrderNumber: workOrderDetails?.workOrderNumber,
        date: moment(workOrderDetails?.date).format("YYYY-MM-DD"),
        title: workOrderDetails?.title,
        siteId: workOrderDetails?.siteId,
        remark: workOrderDetails?.remark,
        gstType: workOrderDetails?.gstType,
        paymentTerms: workOrderDetails?.paymentTerms,
        startDate: moment(workOrderDetails?.startDate).format("YYYY-MM-DD"),
        endDate: moment(workOrderDetails?.endDate).format("YYYY-MM-DD"),
        totalAmount: workOrderDetails?.totalAmount,
        taxableAmount: workOrderDetails?.taxableAmount,
      });
      if (workOrderDetails?.documents?.length > 0) {
        setExistingDocuments(workOrderDetails?.documents);
      }
    }
  }, [siteList, state.workOrderDetails]);

  const getAssignedSites = () => {
    const option = {
      method: "GET",
    };
    const url = `${apiUrl?.get_user_site}?pageSize=${100}`;
    callApi(url, option).then((res) => {
      if (res?.status === true) {
        setSiteList((prev) => ({
          ...prev,
          assignedSites: res?.data?.site,
        }));
      } else {
        toast.error(res?.message);
      }
    });
  };

  const GetAllSitesList = () => {
    let options = {
      method: "GET",
    };
    let API = apiUrl.get_site + `?type=site&pageSize=${100}`;
    callApi(API, options).then((response) => {
      if (response?.status === true) {
        setSiteList((prev) => ({
          ...prev,
          OandMSites: response?.data?.site?.filter(
            (item) => item?.type === "O&M",
          ),
          projectSites: response?.data?.site?.filter(
            (item) => item?.type === "project",
          ),
        }));
      }
    });
  };

  const onSubmit = (data) => {
    if (existingDocuments?.length === 0 && files?.length === 0) {
      toast.info("Please select document before submit!");
      return;
    }

    const postData = {
      workOrderNumber: data?.workOrderNumber,
      date: data?.date,
      title: data?.title,
      siteId: data?.siteId,
      startDate: data?.startDate,
      endDate: data?.endDate,
      phone:
        state.phone.length > 0
          ? JSON.stringify(state.phone)
          : JSON.stringify([]),
      email:
        state.email.length > 0
          ? JSON.stringify(state.email)
          : JSON.stringify([]),
      gstType: data?.gstType,
      paymentTerms: data?.paymentTerms,
      totalAmount: data?.totalAmount,
      taxableAmount: data?.taxableAmount,
      remark: data?.remark,
    };
    // console.log("postData=======>", postData);
    // console.log("Data=======>", data);

    const formData = new FormData();
    Object.keys(postData).forEach((key) => {
      const value = postData[key];
      if (value) {
        formData.append(key, value);
      }
    });
    const updatedWorkOrderItems = data?.workOrderItem?.map((item) => {
      const formatted = { ...item };
      if (formatted.itemId) {
        formatted.id = formatted.itemId;
        delete formatted.itemId;
      }
      delete formatted.originalQuantity;
      return formatted;
    });
    formData.append("workOrderItem", JSON.stringify(updatedWorkOrderItems));

    if (files?.length > 0) {
      files.forEach((fileObj) => {
        formData.append(fileObj?.file?.name, fileObj.file);
      });
    }

    const options = {
      method: "POST",
      form_data: formData,
    };

    let API = location?.state
      ? apiUrl?.update_workOrder + `?workorderId=${location?.state?.data?.id}`
      : apiUrl?.create_workOrder;
    setIsLoading(true);
    callApi(API, options).then((response) => {
      setIsLoading(false);
      if (response?.status === true) {
        toast.success(response?.message);
        navigate(-1);
      } else {
        toast.error(response?.message);
      }
    });
  };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      if (selectedFile.size > 6 * 1024 * 1024) {
        toast.error("File size must be less than 6MB");
        event.target.value = "";
        return;
      }
      setFiles((prevFiles) => [
        ...prevFiles,
        { key: selectedFile.name, file: selectedFile }, // Use file name as key
      ]);
    }
    event.target.value = ""; // Allow reselecting the same file
  };

  const removeFile = (fileName) => {
    setFiles((prevFiles) =>
      prevFiles.filter((fileObj) => fileObj.key !== fileName),
    );
  };

  const handleDeleteDocument = (docId) => {
    const API = `${apiUrl.delete_document}?documentId=${docId}`;
    callApi(API, { method: "GET" }).then((response) => {
      if (response?.status === true) {
        setExistingDocuments((prev) => prev.filter((doc) => doc.id !== docId));
        // toast.success(response.message);
      } else {
        toast.error(response.message);
      }
    });
  };

  const handleChangeSite = (e) => {
    const value = e.target.value;
    const site =
      userDetails?.type !== 2
        ? siteList.assignedSites?.find((item) => item?.site?.id == value)
        : siteList.OandMSites?.find((item) => item?.site?.id == value);
    if (site?.site?.startDate && site?.site?.endDate) {
      setState((prev) => ({
        ...prev,
        startDate: site?.site?.startDate,
        endDate: site?.site?.endDate,
      }));
      setValue("startDate", "");
      setValue("endDate", "");
    } else {
      toast.error("This site doesn't have start date and end date");
      setState((prev) => ({
        ...prev,
        startDate: "",
        endDate: "",
      }));
      setValue("startDate", "");
      setValue("endDate", "");
    }
  };

  return (
    <>
      <div className="content container-fluid">
        <div className="content-head mb-5 d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center justify-content-start gap-4">
            <button
              role="button"
              className="btn back-arrow"
              onClick={() => navigate(-1)}
            >
              <BackArrowIcon />
            </button>
            <h1 className="mb-0">
              {location?.state ? "Update" : "Add"} Work Order
            </h1>
          </div>
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <label className="form-label" htmlFor="bDate">
                      Work Order Number<span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="bDate"
                      placeholder="Enter work order no."
                      {...register("workOrderNumber", {
                        required: "This field is Required",
                      })}
                    />
                    <ErrorMessage message={errors?.workOrderNumber?.message} />
                  </div>
                </div>
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <label className="form-label" htmlFor="bDate">
                      Date<span className="text-danger">*</span>
                    </label>
                    <Controller
                      name="date"
                      control={control}
                      rules={{
                        required: "This field is Required",
                      }}
                      defaultValue={moment().format("YYYY-MM-DD")}
                      render={({ field }) => (
                        <DatePicker size="sm"
                          {...field}
                          id="bDate"
                          format="dd/MM/yyyy"
                          oneTap
                          placeholder="dd/mm/yyyy"
                          style={{ width: "100%" }}
                          value={field.value ? new Date(field.value) : null}
                          onChange={(date) => {
                            field.onChange(date ? moment(date).format("YYYY-MM-DD") : "");
                          }}
                          cleanable={false}
                        />
                      )}
                    />
                    <ErrorMessage message={errors?.date?.message} />
                  </div>
                </div>
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <label className="form-label" htmlFor="bDate">
                      Title<span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="bDate"
                      placeholder="Enter title"
                      {...register("title", {
                        required: "This field is Required",
                      })}
                    />
                    <ErrorMessage message={errors?.title?.message} />
                  </div>
                </div>
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <label className="form-label">
                      Site<span className="text-danger">*</span>
                    </label>
                    {userDetails?.type === 2 && (
                      <select
                        className="form-select fw-medium w-100"
                        name="siteId"
                        {...register("siteId", {
                          required: "This field is Required",
                        })}
                        onChange={handleChangeSite}
                      >
                        <option value={""} className="d-none">
                          Select Site
                        </option>
                        <optgroup label="O&M">
                          {siteList?.OandMSites?.length > 0 ? (
                            siteList?.OandMSites.map((item, index) => (
                              <option
                                key={index}
                                value={
                                  userDetails?.type == 2
                                    ? item?.id
                                    : `${item?.siteId}`
                                }
                              >
                                {item?.name || item?.site?.name}
                              </option>
                            ))
                          ) : (
                            <option disabled>No site found</option>
                          )}
                        </optgroup>
                        <optgroup label="Project">
                          {siteList?.projectSites?.length > 0 ? (
                            siteList?.projectSites.map((item, index) => (
                              <option key={index} value={item?.id}>
                                {item?.name}
                              </option>
                            ))
                          ) : (
                            <option disabled>No office found</option>
                          )}
                        </optgroup>
                      </select>
                    )}

                    {userDetails?.type !== 2 && (
                      <select
                        className="form-select form-control"
                        aria-label="Default select example"
                        {...register("siteId", {
                          required: "This field is Required",
                        })}
                        onChange={handleChangeSite}
                      >
                        <option value="" className="d-none text-muted">
                          Select Site
                        </option>
                        {siteList?.assignedSites?.length > 0 ? (
                          siteList?.assignedSites?.map((item, index) => (
                            <option key={index} value={item?.site?.id}>
                              {item?.site?.name}
                            </option>
                          ))
                        ) : (
                          <option className="text-muted" value="">
                            No site available
                          </option>
                        )}
                      </select>
                    )}
                    <ErrorMessage message={errors?.siteId?.message} />
                  </div>
                </div>
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <label className="form-label">
                      GST Type<span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-select form-control"
                      aria-label="Default select example"
                      {...register("gstType", {
                        required: "Please select GST Type",
                      })}
                    >
                      <option value="" className="d-none">
                        Select GST Type
                      </option>
                      <option value={"IGST"}>IGST</option>
                      <option value={"CGST + SGST"}>CGST + SGST</option>
                    </select>
                    <ErrorMessage message={errors?.gstType?.message} />
                  </div>
                </div>

                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <label className="form-label">
                      Payment Term<span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-select form-control"
                      aria-label="Default select example"
                      {...register("paymentTerms", {
                        required: "Please select payment term",
                      })}
                    >
                      <option value="" className="d-none">
                        Select Payment Term
                      </option>
                      <option value={"Same-Day Settlement"}>
                        Same-Day Settlement
                      </option>
                      <option value={"With-in 07 days"}>With-in 07 days</option>
                      <option value={"With-in 15 days"}>With-in 15 days</option>
                      <option value={"With-in 30 days"}>With-in 30 days</option>
                      <option value={"With-in 45 days"}>With-in 45 days</option>
                    </select>
                    <ErrorMessage message={errors?.paymentTerms?.message} />
                  </div>
                </div>
                <div className="py-3 mb-4">
                  <div className="row align-items-center">
                    {/* Time Period */}
                    <div className="col-12 col-md-4 mb-3">
                      <div className="d-flex align-items-center w-100 mt-4">
                        <span
                          className="fw-semibold me-2"
                          style={{ whiteSpace: "nowrap" }}
                        >
                          Time Period
                        </span>

                        <div
                          style={{
                            height: "2px",
                            backgroundColor: "#ddd",
                            flexGrow: 1,
                            position: "relative",
                            top: "1px",
                          }}
                        ></div>
                      </div>
                    </div>

                    {/* Start Date */}
                    <div className="col-12 col-md-4 mb-3">
                      <label className="form-label mb-1">
                        Start Date <span className="text-danger">*</span>
                      </label>
                      <Controller
                        name="startDate"
                        control={control}
                        rules={{
                          required: "Please select start date",
                        }}
                        render={({ field }) => (
                          <DatePicker size="sm"
                            {...field}
                            format="dd/MM/yyyy"
                            oneTap
                            placeholder="dd/mm/yyyy"
                            style={{ width: "100%" }}
                            disabled={!state.startDate}
                            value={field.value ? new Date(field.value) : null}
                            onChange={(date) => {
                              const formattedDate = date ? moment(date).format("YYYY-MM-DD") : "";
                              field.onChange(formattedDate);
                              setValue("endDate", "");
                            }}
                            shouldDisableDate={(date) =>
                              state.startDate ? date < new Date(moment(state.startDate).startOf('day')) : false
                            }
                            cleanable={false}
                          />
                        )}
                      />
                      <ErrorMessage message={errors?.startDate?.message} />
                    </div>

                    {/* End Date */}
                    <div className="col-12 col-md-4 mb-3">
                      <label className="form-label mb-1">
                        End Date <span className="text-danger">*</span>
                      </label>
                      <Controller
                        name="endDate"
                        control={control}
                        rules={{
                          required: "Please select end date",
                        }}
                        render={({ field }) => (
                          <DatePicker size="sm"
                            {...field}
                            format="dd/MM/yyyy"
                            oneTap
                            placeholder="dd/mm/yyyy"
                            style={{ width: "100%" }}
                            disabled={!state.endDate}
                            value={field.value ? new Date(field.value) : null}
                            onChange={(date) => {
                              field.onChange(date ? moment(date).format("YYYY-MM-DD") : "");
                            }}
                            shouldDisableDate={(date) =>
                              state.endDate ? date > new Date(moment(state.endDate).endOf('day')) : false
                            }
                            cleanable={false}
                          />
                        )}
                      />
                      <ErrorMessage message={errors?.endDate?.message} />
                    </div>
                  </div>
                </div>

                <div className="col-12 col-md-6 col-lg-4">
                  <MultipleGTC
                    setGtc={setState}
                    gtcList={state?.phone}
                    name={"phone"}
                    title="Phone"
                    required={false}
                    placeholder="Enter Phone No."
                    onWheel={(e) => e.target.blur()}
                  />
                </div>
                <div className="col-12 col-md-6 col-lg-4">
                  <MultipleGTC
                    setGtc={setState}
                    gtcList={state?.email}
                    name={"email"}
                    title="Email"
                    required={false}
                    placeholder="Enter Email"
                  />
                </div>

                <div className="my-3">
                  <table className="table table-bordered table-responsive">
                    <thead className="table-dark">
                      <tr>
                        <th>Item</th>
                        <th>HSN</th>
                        <th>Qty</th>
                        <th>Unit</th>
                        <th>Rate</th>
                        <th>Taxable Amount</th>
                        <th>GST</th>
                        <th>GST AMOUNT</th>
                        <th>Total</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {fields?.map((field, index) => (
                        <tr key={field.id}>
                          <td style={{ width: "22rem" }}>
                            <input
                              {...register(`workOrderItem.${index}.item`)}
                              className="form-control"
                              type="text"
                              placeholder="Item name"
                              required
                            />
                          </td>
                          <td style={{ width: "11rem" }}>
                            <input
                              {...register(`workOrderItem.${index}.hsnCode`)}
                              className="form-control"
                              type="text"
                              required
                            />
                          </td>
                          <td style={{ width: "10rem" }}>
                            <input
                              {...register(`workOrderItem.${index}.quantity`, {
                                onChange: () => handleQtyChange(index),
                                validate: (value) => {
                                  if (field.itemId && Number(value) < Number(field.originalQuantity)) {
                                    return `Min quantity: ${field.originalQuantity}`;
                                  }
                                  return true;
                                }
                              })}
                              className="form-control"
                              type="number"
                              step="0.01"
                              min={field.itemId ? field.originalQuantity : 0}
                              required
                              onWheel={(e) => e.target.blur()}
                            />
                            <ErrorMessage message={errors?.workOrderItem?.[index]?.quantity?.message} />
                          </td>
                          <td style={{ width: "14rem" }}>
                            <select
                              {...register(`workOrderItem.${index}.unit`, {
                                onChange: () => handleQtyChange(index),
                              })}
                              className="form-select"
                              required
                            >
                              <option value="">Select</option>
                              {UnitCollection?.map((unit, index) => {
                                return (
                                  <option key={index} value={unit.value}>
                                    {unit.label}
                                  </option>
                                );
                              })}
                            </select>
                          </td>

                          <td style={{ width: "14rem" }}>
                            <input
                              {...register(`workOrderItem.${index}.rate`, {
                                onChange: () => handleQtyChange(index),
                              })}
                              className="form-control"
                              type="number"
                              step="0.01"
                              min={0}
                              required
                              disabled={!!field.itemId}
                              onWheel={(e) => e.target.blur()}
                            />
                          </td>
                          <td style={{ width: "15rem" }}>
                            <input
                              {...register(
                                `workOrderItem.${index}.totalAmount`,
                              )}
                              className="form-control"
                              type="number"
                              disabled
                            />
                          </td>
                          <td style={{ width: "10rem" }}>
                            <select
                              className="form-select form-control"
                              placeholder="Select GST"
                              {...register(`workOrderItem.${index}.gst`, {
                                onChange: () => handleQtyChange(index),
                              })}
                              required
                              disabled={!!field.itemId}
                            >
                              <option value="" className="d-none">
                                GST
                              </option>
                              <option value="0">0%</option>
                              <option value="5">5%</option>
                              <option value="12">12%</option>
                              <option value="18">18%</option>
                              <option value="28">28%</option>
                            </select>
                          </td>
                          <td style={{ width: "15rem" }}>
                            <input
                              {...register(`workOrderItem.${index}.gstAmount`)}
                              className="form-control"
                              type="number"
                              disabled
                            />
                          </td>
                          <td style={{ width: "15rem" }}>
                            <input
                              {...register(
                                `workOrderItem.${index}.taxableAmount`,
                              )}
                              className="form-control"
                              type="number"
                              disabled
                            />
                          </td>
                          <td style={{ width: "15rem" }}>
                            <button
                              type="button"
                              className="btn btn-danger"
                              onClick={() => remove(index)}
                              disabled={fields.length === 1 || !!field.itemId}
                            >
                              <DeleteIcon />
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot className="fw-bold bg-light">
                      <tr>
                        <td colSpan="5" className="text-start">
                          Total:
                        </td>
                        <td>{totals.taxableAmount}</td>
                        <td></td>
                        <td>{totals.totalGstAmount}</td>
                        <td>{totals.totalAmount}</td>
                        <td></td>
                      </tr>
                    </tfoot>
                  </table>
                  <div className="d-flex justify-content-end">
                    <button
                      type="button"
                      className="btn btn-btn-outline-primary border"
                      onClick={() =>
                        append({
                          item: "",
                          hsnCode: "",
                          quantity: "",
                          unit: "",
                          gst: "",
                          gstAmount: "",
                          rate: "",
                          totalAmount: "",
                          taxableAmount: "",
                        })
                      }
                    >
                      <PlusIcon />
                    </button>
                  </div>
                </div>
                <div className="col-12 col-md-6 col-lg-8 w-100">
                  <div className="form-group mb-3">
                    <label htmlFor="desc" className="form-label">
                      Remark<span className="text-danger">*</span>
                    </label>
                    <textarea
                      className="form-control "
                      id="desc"
                      rows={3}
                      name="remark"
                      {...register("remark", {
                        required: "This field is Required",
                      })}
                    />
                    <ErrorMessage message={errors?.remark?.message} />
                  </div>

                  <div className="row">
                    <div className="col-12  " />
                    <div className="col-12 col-md-6 col-lg-5">
                      <div className="form-group mb-3">
                        <label className="form-label" htmlFor="ref">
                          Reference<span className="text-danger">*</span>
                        </label>
                        <input
                          type="file"
                          className="form-control d-none"
                          id="documentUpload"
                          accept="image/*,application/pdf"
                          onChange={handleFileChange}
                        />
                        <label
                          htmlFor="documentUpload"
                          className="form-label rounded-4 cursor-pointer d-flex align-items-center justify-content-center"
                          style={{
                            display: "inline-block",
                            cursor: "pointer",
                            padding: 5,
                            backgroundColor: "rgb(245, 245, 245)",
                            borderRadius: 8,
                            minWidth: 150,
                          }}
                        >
                          <div className="d-flex flex-column">
                            <span className="placeholder-img">
                              <UploadPlusIcon />
                            </span>
                            <span className="text-muted">Choose Files </span>
                          </div>
                        </label>
                        <div className="preview-section p-1 mt-3" />
                      </div>
                    </div>
                  </div>
                  {/* File Preview Section */}
                  <div className="preview-section p-1 mt-3 col-lg-5">
                    {files?.length > 0 &&
                      files.map((fileObj, index) => (
                        <div
                          key={`file-${index}`}
                          className="d-flex align-items-center justify-content-between p-1 border rounded mb-2"
                          style={{
                            backgroundColor: "#f8f9fa",
                            cursor: "pointer",
                          }}
                        >
                          <div
                            className="w-100"
                            onClick={() => {
                              setSelectedDocument(fileObj?.file);
                              toggleModal();
                            }}
                          >
                            <span className="fs-5">{fileObj?.file?.name}</span>
                          </div>
                          <button
                            className="text-danger mx-2 bg-light"
                            onClick={() => removeFile(fileObj.key)}
                          >
                            <DeleteIcon />
                          </button>
                        </div>
                      ))}

                    {existingDocuments?.length > 0 &&
                      existingDocuments.map((doc, index) => (
                        <div
                          key={`doc-${index}`}
                          className="d-flex align-items-center justify-content-between p-1 border rounded mb-2"
                          style={{
                            backgroundColor: "#f8f9fa",
                            cursor: "pointer",
                          }}
                        >
                          <div
                            className="w-100"
                            onClick={() => {
                              const docUrl = {
                                url: doc?.url,
                              };
                              setSelectedDocument(docUrl);
                              toggleModal();
                            }}
                          >
                            <span className="fs-5">{doc?.name}</span>
                          </div>
                          <button
                            type="button"
                            className="text-danger mx-2 bg-light"
                            onClick={() => handleDeleteDocument(doc.id)}
                          >
                            <DeleteIcon />
                          </button>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-end gap-4">
                <button
                  className="btn btn-secondary px-5"
                  type="button"
                  onClick={() => navigate(-1)}
                >
                  Cancel
                </button>
                <button
                  disabled={isLoading}
                  type="submit"
                  className="btn btn-primary px-5"
                >
                  {isLoading ? <Spinner /> : location?.state ? "Update" : "Add"}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
      <ViewDocumentModal
        modal={modal}
        toggle={toggleModal}
        selectedDocument={selectedDocument}
      />
    </>
  );
}
